import { Navigate, Outlet } from "react-router-dom";

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  } catch (error) {
    return true;
  }
};

const ProtectedRoute = ({ allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !user.accessToken || isTokenExpired(user.accessToken)) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(user.userRole[0])) {
    localStorage.clear();
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;